// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backgroundDefault": "#1a1a19",
	"backgroundDark": "#fff",
	"containerDefault": "#262626",
	"containerSubtle": "#3b3a39",
	"backgroundSubtle": "#3b3a39",
	"containerStrong": "#575655",
	"borderSubtle": "#494847",
	"borderStrong": "#797876",
	"borderInverse": "#efedea",
	"dividerDefault": "hsla(0,0%,100%,.2)",
	"interactivePrimary": "#fff",
	"dividerInverse": "rgba(0,0,0,.08)",
	"interactiveBrand": "#f36805",
	"interactiveInverse": "#262626",
	"interactiveSecondary": "#494847",
	"containerInverse": "#fff",
	"interactiveForm": "#9e9c9a",
	"overlay": "rgba(0,0,0,.55)",
	"borderDefault": "#575655",
	"supportError": "#e22c3e",
	"supportDarkError02": "#491e24",
	"supportNeutral": "#1a1a19",
	"containerDark": "#262626",
	"supportWarning": "#f6c243",
	"supportWarning02": "#474630",
	"supportPositive02": "#273f33",
	"supportError02": "#491e24",
	"supportInfoInverse": "#125fca",
	"supportPositiveInverse": "#017a39",
	"supportInfo02": "#083343",
	"supportBrand01": "#ff8000",
	"supportBrand02": "#41301f",
	"supportBrand03": "#c1dade",
	"supportBrand05": "#f6c243",
	"supportBrand06": "#5b3d5b",
	"interactiveLight": "#fff",
	"supportBrand07": "#f75e28",
	"contentDefault": "#fff",
	"contentSubdued": "#d7d9da",
	"contentInteractiveBrand": "#ff8000",
	"contentInteractivePrimary": "#242e30",
	"supportInfo": "#7aadf6",
	"contentInteractiveTertiary": "#fff",
	"contentInteractiveSecondary": "#fff",
	"supportPositive": "#22bf65",
	"contentInteractiveDark": "#242e30",
	"supportBrand04": "#f2a6b0",
	"contentInteractiveLight": "#fff",
	"contentLight": "#fff",
	"contentLink": "#fff",
	"contentLinkDistinct": "#242e30",
	"contentLinkInverse": "#242e30",
	"contentInteractiveInverse": "#fff",
	"contentError": "#f68179",
	"contentDisabled": "#8c999b",
	"contentBrand": "#ff8000",
	"contentPositive": "#22bf65",
	"hover02": "4%",
	"hover01": "8%",
	"contentInteractiveError": "#f68179",
	"active02": "12%",
	"disabled01": "#3b3a39",
	"focus": "#000",
	"focusOuter": "#7aadf6",
	"focusHighContrastInner": "#000",
	"focusHighContrastOuter": "#7aadf6",
	"contentLinkLight": "#fff",
	"contentInverse": "#242e30",
	"active01": "20%",
	"skeleton02": "#494847",
	"skeleton01": "#3b3a39"
};
export default ___CSS_LOADER_EXPORT___;
